import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  FiSearch,
  FiTrash2,
  FiEdit,
  FiEye,
  FiX,
  FiUpload,
  FiDownload,
} from "react-icons/fi"; // Import necessary icons
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert"; // Import for confirmation dialog
import "react-confirm-alert/src/react-confirm-alert.css"; // Import the confirmation dialog CSS
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../../Loader/loader";
const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: "Segoe UI", "Semibold";
  color: #2b3497;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row; /* Align radio buttons horizontally */
  margin-bottom: 20px; /* Provide some spacing between radio group and other elements */
`;

const RadioLabel = styled.label`
  margin-right: 20px; /* Adjust spacing between radio button and label */
  display: flex;
  align-items: center;
  color: #293495; /* Text color */
  font-weight: 600;
`;

const RadioInput = styled.input`
  margin-right: 5px; /* Adjust spacing between radio buttons */
  color: #293495; /* Radio button color */
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(
    to right,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
  cursor: pointer;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 29px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 1000;
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  margin: 0;
  color: #293495;
`;

const CloseIcon = styled(FiX)`
  cursor: pointer;
  color: #293495;
`;

const InputGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const InputRow = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
`;

const InputField = styled.div`
  flex: 0 0 48%;
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;
const InputFieldCheckbox = styled.div`
  width: 48%;
`;

const Label = styled.label`
  margin-bottom: 5px;
  font-weight: 600;
  color: #000;
  &::after {
    content: "*";
    color: red;
    margin-left: 5px;
  }
`;

const LabelN = styled.label`
  margin-bottom: 5px;
  font-weight: 600;
  color: #000;
`;

const Input = styled.input`
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  outline: none; /* Remove default focus outline */
    /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;

const Dropdown = styled.select`
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  background: #fff;
  outline: none; /* Remove default focus outline */
`;

const StyledDatePicker = styled(DatePicker)`
  width: 375px;
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  outline: none; /* Remove default focus outline */
  &::placeholder {
    font-size: 14px;
    color: #999; /* optional */
  }
`;

const SubmitButton = styled.button`
  background-color: #293495;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 5px;
  margin-left: 10px;
  font-size: 16px;
`;

const ResetButton = styled.button`
  background-color: red;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 5px;
  margin-left: 10px;
  font-size: 16px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;
const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;

  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const Button = styled.button`
  background-color: #2b3497;
  color: #fff;
  box-shadow: 0px 5px 10px #2b349754;
  border-radius: 12px;
  opacity: 1;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #1e2a6d;
  }
  &:active {
    background-color: #162055;
  }
`;

const AddEmployeePage = () => {
  const [tableData, setTableData] = useState([]); // Initialize without dummy data
  const [searchQuery, setSearchQuery] = useState("");
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);

  const [loading, setLoading] = useState(false); // Global loading state
  const [selectedRadio, setSelectedRadio] = useState(""); // Track selected radio button
  const [formValues, setFormValues] = useState({
    employeeNo: "",
    // employeeName: '',
    firstName: "",
    middleName: "",
    lastName: "",
    employeeMailId: "",
    employeeMobile: "",
    employeeLocation: "",
    employeeTypeDesc: "",
    nationality: "",
    employeeDepartment: "",
    employeeDesignation: "",
    buHeadMailId: "",
    employeeDOJ: "",
    managerMailID: "",
    buHeadId: "",
    employeeReportingTo: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [formValuesUpdate, setFormValuesUpdate] = useState({
    employeeNo: "",
    // employeeName: '',
    firstName: "",
    middleName: "",
    lastName: "",
    employeeMailId: "",
    employeeMobile: "",
    employeeLocation: "",
    employeeTypeDesc: "",
    entityId: "",
    name: "",
    employeeDepartment: "",
    employeeDesignation: "",
    buHeadMailId: "",
    employeeDOJ: "",
    managerMailID: "",
    buHeadId: "",
    employeeReportingTo: "",
    isDeleted: "",
  });
  const [formErrorsUpdate, setFormErrorsUpdate] = useState({});
  const [locations, setLocations] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);
  const [empType, setEmpType] = useState([]);
  const [empEntity, setEmpEntity] = useState([]);

  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [managerMails, setManagerMail] = useState([]);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const rowsPerPage = 7;

  // Fetch employee data from API

  const fetchEmployeeData = async () => {
    try {
      const response = await axios.get("/Employee/GetAllEmployees");
      setTableData(response.data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };
  useEffect(() => {
    fetchEmployeeData();
  }, []);
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === "asc") {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };
  const [visitorTypeOptions, setVisitorTypeOptions] = useState([]);

  const handleSort = (column) => {
    const direction =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  }; // Empty dependency array means this useEffect runs once when the component mounts

  // Fetch locations and designations data
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const locationsResponse = await axios.get("/Location");
        setLocations(locationsResponse.data);
        setFormValuesUpdate((prevValues) => ({
          ...prevValues,
          employeeLocation: editData.employeeLocationId || "", // Set preselected location ID here
        }));

        const designationsResponse = await axios.get("/Designation");
        const filterActiveDesignations = designationsResponse.data.filter((designation) => designation.isDeleted === false);
        setDesignations(filterActiveDesignations ? filterActiveDesignations : []);
        const nationalityResponse = await axios.get("/Nationality");
        setFormValuesUpdate((prevValues) => ({
          ...prevValues,
          name: editData.nationality || "", // Set preselected location ID here
        }));
        setNationalityList(nationalityResponse.data);
        const empTypeResponse = await axios.get("/EmployeeType");
        setEmpType(empTypeResponse.data);
        const empEntyType = await axios.get("/Entity/GetEntity");
        setEmpEntity(empEntyType.data);
        setFormValuesUpdate((prevValues) => ({
          ...prevValues,
          entityId: editData.entityID || "", // Set preselected location ID here
        }));
        setFormValuesUpdate((prevValues) => ({
          ...prevValues,
          employeeTypeDesc: editData.employeeTypeDesc || "", // Set preselected location ID here
        }));
        const departmentsResponse = await axios.get("/Department");
        const filterActiveDepartments = departmentsResponse.data.filter((department) => department.isDeleted === false);
        setDepartments(filterActiveDepartments ? filterActiveDepartments : []);

        const managerMailResponse = await axios.get(
          "/Employee/GetAllEmployees",
        );
        setManagerMail(managerMailResponse.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
      try {
        const response = await axios.get("/VisitorType");
        console.log("response", response.data);
        const formattedOptions = response.data.map((item) => ({
          value: item.id,
          label: item.visitorTypeDesc,
        }));
        setVisitorTypeOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching visitor type data:", error);
      }
    };

    fetchDropdownData();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  const [editData, setEditData] = useState("");
  const [selectedVisitorTypesUpdate, setSelectedVisitorTypesUpdate] = useState(
    [],
  );

  const handleEdit = (row) => {
    setFormErrorsUpdate({}); // Clear any form errors as well
    console.log("Emp row data", row);
    console.log("Emp row data", row.employeeLocationId);
    const idsArray = row.visitorTypeId
      ? row.visitorTypeId.split(",").map((id) => parseInt(id, 10))
      : [];
    const preSelected = visitorTypeOptions.filter((opt) =>
      idsArray.includes(opt.value),
    );
    setSelectedVisitorTypesUpdate(preSelected);

    setEditData(row);
    setFormValuesUpdate({
      entityId: row.entityID,
      employeeNo: row.employeeNo,
      // employeeName: row.employeeName,
      firstName: row.firstName,
      middleName: row.middleName,
      lastName: row.lastName,
      employeeMailId: row.employeeMailId,
      employeeMobile: row.employeeMobile,
      employeeLocation: parseInt(row.employeeLocationId, 10),
      employeeTypeDesc: row.employeeTypeDesc,
      name: row.nationality,
      employeeDepartment: row.departmentId || "",
      employeeDesignation: parseInt(row.designationId, 10),
      buHeadMailId: row.buHeadMailId,
      employeeDOJ: row.employeeDOJ,
      managerMailID: row.managerMailID,
      buHeadId: row.buHeadId,
      employeeReportingTo: row.employeeReportingTo,
      isDeleted: row?.isDeleted || false,
    });
    setIsModalOpenUpdate(true);
  };

  const handleDelete = (employeeNo) => {
    // Show confirmation dialog
    confirmAlert({
      title: <span style={{ color: "#dc3545" }}>Warning</span>,
      message: "Are you sure you want to delete this row?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              // Construct the request body with necessary fields
              const existingEmployee = tableData.find(
                (employee) => employee.employeeNo === employeeNo,
              );

              const requestBody = {
                ...existingEmployee,
                isDeleted: true, // Mark the employee as deleted
                modifiedOn: new Date().toISOString(), // Current timestamp
                modifiedBy: "", // Replace with actual user performing the delete
              };

              // Call the API to delete the row
              const response = await axios.put(`/employee`, requestBody);

              if (response.status === 200) {
                // Remove the row from the tableData
                setTableData((prevData) =>
                  prevData.filter((row) => row.employeeNo !== employeeNo),
                );

                // Show success toast message
                toast.success("Deleted successfully");
              } else {
                // Handle any errors from the API
                toast.error("Failed to delete the item");
              }
            } catch (error) {
              console.error("Error deleting data:", error);
              toast.error("There was an error deleting the item");
            }
          },
        },
        {
          label: "No",
          onClick: () => {
            // Show cancel message
            toast.info("Delete cancelled");
          },
        },
      ],
    });
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormValues("");
    setSelectedRadio(""); // Reset selected radio button
  };
  const handleCloseModalUpdate = () => {
    setIsModalOpenUpdate(false);
    setFormValuesUpdate("");
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues({ ...formValues, [name]: value });
  // };
  const [nationalityCode, setNationalityCode] = useState("");

  const handleInputChange = (e) => {
    if (!e.target && e instanceof Date) {
      const year = e.getFullYear();
      const month = String(e.getMonth() + 1).padStart(2, "0");
      const day = String(e.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`; // local date format (YYYY-MM-DD)

      setFormValues((prev) => ({
        ...prev,
        employeeDOJ: formattedDate,
      }));
      return;
    }

    const { name, value } = e.target;

    // Check if the input is for mobile number and contains only digits
    if (name === "employeeMobile") {
      if (/^\d*$/.test(value)) {
        // Regex to allow only digits
        setFormValues({
          ...formValues,
          [name]: value,
        });
      }
    } else {
      // For other fields, update normally
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
    if (name === "nationality") {
      const selectedNation = nationalityList.find((n) => n.name === value);
      setNationalityCode(selectedNation?.nationalityCode || "");

      setFormValues((prev) => ({
        ...prev,
        nationality: value,
        employeeMobile: "", // clear mobile number
      }));
    }
  };

  const handleInputChangeUpdate = (e) => {
    if (!e.target && e instanceof Date) {
      // Format the date as YYYY-MM-DD in local time
      const year = e.getFullYear();
      const month = String(e.getMonth() + 1).padStart(2, "0");
      const day = String(e.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      setFormValuesUpdate((prev) => ({
        ...prev,
        employeeDOJ: formattedDate,
      }));
      return;
    }
    const { name, value } = e.target;

    console.log("name", name);
    console.log("value", value);

    // Check if the input is for mobile number and contains only digits
    if (name === "employeeMobile") {
      if (/^\d*$/.test(value)) {
        // Regex to allow only digits
        setFormValuesUpdate({
          ...formValuesUpdate,
          [name]: value,
        });
      }
    } else if (name === "employeeDOJ") {
      setFormValuesUpdate((prev) => ({
        ...prev,
        [name]: value, // already in 'YYYY-MM-DD' format
      }));
    }
    {
      // For other fields, update normally
      setFormValuesUpdate({
        ...formValuesUpdate,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/; // Adjust according to your mobile number format

    Object.keys(formValues).forEach((key) => {
      if (!formValues[key]) {
        errors[key] = "This field is required";
      }
    });
    if (
      formValues.employeeMailId &&
      !emailRegex.test(formValues.employeeMailId)
    ) {
      errors.employeeMailId = "Invalid email format";
    }

    if (
      formValues.employeeMobile &&
      !mobileRegex.test(formValues.employeeMobile)
    ) {
    }
    if (formValues.employeeNo == "") {
      errors.employeeMobile = "please fill the mobile number";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateFormUpdate = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/; // Adjust according to your mobile number format

    Object.keys(formValuesUpdate).forEach((key) => {
      if (!formValuesUpdate[key]) {
        errors[key] = "This field is required";
      }
    });
    if (
      formValuesUpdate.employeeMailId &&
      !emailRegex.test(formValuesUpdate.employeeMailId)
    ) {
      errors.employeeMailId = "Invalid email format";
    }

    if (
      formValuesUpdate.employeeMobile &&
      !mobileRegex.test(formValuesUpdate.employeeMobile)
    ) {
      errors.employeeMobile = "Invalid mobile number format";
    }

    setFormErrorsUpdate(errors);
    return Object.keys(errors).length === 0;
  };
  const handleReset = () => {
    setFormValues({
      employeeNo: "",
      firstName: "",
      lastName: "",
      middleName: "",
      employeeMailId: "",
      employeeMobile: "",
      employeeLocation: "",
      employeeTypeDesc: "",
      entityId: "",
      nationality: "",
      employeeDepartment: "",
      employeeDesignation: "",
      managerMailID: "",
      employeeDOJ: "",
      buHeadMailId: "",
    });
    setSelectedVisitorTypes("");
    setFormErrors({}); // Clear any form errors as well
  };
  const handleResetUpdate = () => {
    setFormValuesUpdate({
      employeeNo: "",
      // employeeName: '',
      firstName: "",
      lastName: "",
      middleName: "",
      employeeMailId: "",
      employeeTypeDesc: "",
      entityId: "",
      name: "",
      employeeMobile: "",
      employeeLocation: "",
      employeeDepartment: "",
      employeeDesignation: "",
      managerMailID: "",
      employeeDOJ: "",
      buHeadMailId: "",
    });
    setSelectedVisitorTypesUpdate("");
    setFormErrorsUpdate({}); // Clear any form errors as well
  };

  const updateDelete = async (data) => {
    console.log("selected Row", data);

    // Toggle isDeleted value
    const updatedData = {
      ...data,
      isDeleted: !data.isDeleted,
    };
    setLoading(true);
    // Make API call
    try {
      const response = await axios.put("/employee", updatedData);
      console.log(response);
      if (response?.status == 200) {
        toast.success(response.data || "Employee deleted successfully");
      } else {
        toast.error("Unable to update employee status");
      }
      fetchEmployeeData();
    } catch (error) {
      console.error("Error updating employee:", error);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong while updating employee",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitUpdate = async () => {
    const responseGetId = await axios.get(
      `/EmployeeType/EmployeeType/${formValuesUpdate.employeeTypeDesc}`,
    );
    const visitorTypeId = Array.isArray(selectedVisitorTypesUpdate)
      ? selectedVisitorTypesUpdate.map((opt) => opt.value).join(",")
      : "";
    const selectedEntity = empEntity.find(
      (e) => e.id === parseInt(formValuesUpdate.entityId, 10),
    );

    const empId = responseGetId.data.id;
    if (
      formValuesUpdate.employeeNo &&
      formValuesUpdate.employeeNo.toString().trim() !== "" &&
      // formValuesUpdate.entityId && formValuesUpdate.entityId.toString().trim() !== "" &&
      formValuesUpdate.firstName &&
      formValuesUpdate.firstName.toString().trim() !== "" &&
      formValuesUpdate.employeeMailId &&
      formValuesUpdate.employeeMailId.toString().trim() !== "" &&
      formValuesUpdate.employeeMobile &&
      formValuesUpdate.employeeMobile.toString().trim() !== "" &&
      formValuesUpdate.employeeLocation &&
      formValuesUpdate.employeeLocation.toString().trim() !== "" &&
      formValuesUpdate.employeeDepartment &&
      formValuesUpdate.employeeDepartment.toString().trim() !== "" &&
      formValuesUpdate.employeeDesignation &&
      formValuesUpdate.employeeDesignation.toString().trim() !== "" &&
      formValuesUpdate.employeeReportingTo &&
      formValuesUpdate.employeeReportingTo.toString().trim() !== "" &&
      formValuesUpdate.employeeDOJ &&
      formValuesUpdate.employeeDOJ.toString().trim() !== "" &&
      formValuesUpdate.employeeTypeDesc &&
      formValuesUpdate.employeeTypeDesc.toString().trim() !== "" &&
      formValuesUpdate.name &&
      formValuesUpdate.name.toString().trim() !== ""
    ) {
      try {
        const reqData = {
          id: editData.id,
          employeeNo: formValuesUpdate.employeeNo,
          employeeName: formValuesUpdate.firstName,
          visitorTypeId: visitorTypeId,
          firstName: formValuesUpdate.firstName,
          lastName: formValuesUpdate.lastName,
          middleName: formValuesUpdate.middleName,
          employeeTypeDesc: formValuesUpdate.employeeTypeDesc,
          entityID: parseInt(formValuesUpdate.entityId, 10),
          entityName: selectedEntity ? selectedEntity.entityName : "",
          employeeTypeID: empId,
          nationality: formValuesUpdate.name,
          employeeMailId: formValuesUpdate.employeeMailId,
          employeeMobile: formValuesUpdate.employeeMobile,
          departmentId: parseInt(formValuesUpdate.employeeDepartment, 10),
          designationId: parseInt(formValuesUpdate.employeeDesignation, 10),
          isDeleted: formValuesUpdate?.isDeleted,
          createdOn: new Date().toISOString(),
          createdBy: "string",
          modifiedOn: new Date().toISOString(),
          modifiedBy: "string",
          managerMailID: formValuesUpdate.managerMailID,
          employeeReportingTo: parseInt(
            formValuesUpdate.employeeReportingTo,
            10,
          ),
          employeeDOJ: formValuesUpdate.employeeDOJ,
          employeeLocationId: parseInt(formValuesUpdate.employeeLocation, 10),
          buHeadId: parseInt(formValuesUpdate.buHeadId, 10),
          buHeadMailId: formValuesUpdate.buHeadMailId,
        };

        const response = await axios.put("/employee", reqData);
        if (
          response.data ===
          "Employee Email is already in use. Please use a different Employee Email."
        ) {
          toast.error(response.data);
          return;
        }

        if (response.data) {
          console.log("Employee updated successfully:", response.data);

          toast.success("Employee Updated Successfully");
          setTableData((prevData) => [...prevData, formValuesUpdate]);
          setShowPagination(true);
        } else {
          toast.error("Failed to update the employee" || response?.message);
        }
      } catch (error) {
        console.error("Error adding employee:", error);
        toast.error("Failed to update the employee");
      }
    } else {
      toast.error("Please fill out all required fields");
      return;
    }
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get("/Employee/GetAllEmployees");
        setTableData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };
    fetchEmployeeData();
    handleCloseModalUpdate(); // Use the function to reset the form and close the modal
  };

  const handleSubmit = async () => {
    console.log("formValues", formValues);

    if (
      formValues.employeeNo !== "" &&
      formValues.firstName !== "" &&
      formValues.employeeMailId !== "" &&
      formValues.employeeMobile !== "" &&
      formValues.employeeLocation !== "" &&
      formValues.employeeDepartment !== "" &&
      formValues.employeeDesignation !== "" &&
      formValues.employeeReportingTo !== "" &&
      formValues.employeeDOJ !== "" &&
      formValues.employeeTypeDesc !== "" &&
      formValues.nationality !== ""
    ) {
      // && formValues.entityId !== ""
      const visitorTypeId = Array.isArray(selectedVisitorTypes)
        ? selectedVisitorTypes.map((opt) => opt.value).join(",")
        : "";

      // const response = await axios.get(`/Employee/Employee/${formValues.employeeNo}`);
      // console.log("response", response.data);
      const responseGetId = await axios.get(
        `/EmployeeType/EmployeeType/${formValues.employeeTypeDesc}`,
      );
      const empId = responseGetId.data.id;

      // console.log("response", response.data);

      // if (response.data.employeeNo == formValues.employeeNo) {
      //   toast.error('Employee number already exists')
      //   return
      // }
      const selectedEntity = empEntity.find(
        (e) => e.id === parseInt(formValues.entityId, 10),
      );

      try {
        const reqData = {
          id: 0,
          employeeNo: formValues.employeeNo,
          visitorTypeId: visitorTypeId,
          employeeName: formValues.firstName,
          employeeMailId: formValues.employeeMailId,
          employeeMobile: formValues.employeeMobile,
          firstName: formValues.firstName,
          middleName: formValues.middleName,
          lastName: formValues.lastName,
          departmentId: parseInt(formValues.employeeDepartment, 10),
          designationId: parseInt(formValues.employeeDesignation, 10),
          isDeleted: false,
          createdOn: new Date().toISOString(),
          createdBy: "string",
          modifiedOn: new Date().toISOString(),
          modifiedBy: "string",
          managerMailID: formValues.managerMailID,
          employeeReportingTo: parseInt(formValues.employeeReportingTo, 10),
          employeeDOJ: formValues.employeeDOJ,
          employeeTypeDesc: formValues.employeeTypeDesc,
          entityID: parseInt(formValues.entityId, 10),
          entityName: selectedEntity ? selectedEntity.entityName : "",
          employeeTypeID: empId,
          nationality: formValues.nationality,
          employeeLocationId: parseInt(formValues.employeeLocation, 10),
          buHeadId: parseInt(formValues.buHeadId, 10),
          buHeadMailId: formValues.buHeadMailId,
        };
        const response = await axios.post(
          "/Employee/AddEmployeeDetails",
          reqData,
        );

        console.log("Employee added successfully:", response.data);
        if (response.data.code === 0) {
          toast.success(response.data.message || "Employee added successfully.");
        } else {
          toast.error(response.data.message || "Failed to save.");
        }
        // if (response.data == "Failed to save") {
        //   toast.error("Failed to save");
        //   return;
        // }

        // toast.success("Employee Added Successfully");
        setTableData((prevData) => [...prevData, formValues]);
        setShowPagination(true);

        handleCloseModal(); // Use the function to reset the form and close the modal
      } catch (error) {
        console.error("Error adding employee:", error);
        toast.error("Failed to add employee");
      }
    } else {
      toast.error("Please fill out all required fields");
    }
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get("/Employee/GetAllEmployees");
        setTableData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };
    fetchEmployeeData();
  };

  // const filteredData = tableData.filter((row) =>
  //   row.employeeName.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  const filteredData = tableData.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );
  const handleDownloadTemplate = () => {
    // Logic to handle downloading the sample template
    const link = document.createElement("a");
    link.href = "/path/to/sample_template.xlsx"; // Replace with the actual path to your sample template
    link.download = "Employee_Sample_Template.xlsx";
    link.click();
  };

  const [isPanelOpen, setIsPanelOpen] = useState(false);

  // Function to toggle the export options panel
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (format === "excel") {
      exportToExcel(); // Call the Excel export function
    } else if (format === "pdf") {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpen(false);
  };
  const exportToExcel = () => {
    const filteredDataNee = filteredData.map((row) => ({
      EntityName: row.entityName,
      employeeNo: row.employeeNo,
      employeeName: row.employeeName,
      employeeType: row.employeeTypeDesc,
      nationality: row.nationality,
      employeeMailId: row.employeeMailId,
      employeeMobile: row.employeeMobile,
      managerMailID: row.managerMailID,
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Reports");

    // Adjust column widths for better alignment
    worksheet["!cols"] = [
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Mobile
      { wpx: 150 }, // Visitor Mobile
      { wpx: 200 }, // Visitor Company
      { wpx: 150 }, // Employee Name
      { wpx: 150 }, // Location Name
      { wpx: 200 }, // Check-In Date Time
    ];

    XLSX.writeFile(workbook, "Employee_Report.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Employee Reports", 14, 16);
    doc.autoTable({
      head: [
        [
          "Entity Name",
          "Employee No",
          "Employee Name",
          "Employee Type",
          "Nationality",
          "Mail Id",
          "Mobile",
          "Manager Mail Id",
        ],
      ],
      body: filteredData.map((row) => [
        row.entityName,
        row.employeeNo,
        row.employeeName,
        row.employeeTypeDesc,
        row.nationality,
        row.employeeMailId,
        row.employeeMobile,
        row.managerMailID,
      ]),
      startY: 30,
      theme: "grid",
    });
    doc.save("Employee_Report.pdf");
  };

  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };
  const fileInputRef = useRef(null);
  const [fileUploaded, setFileUploaded] = useState(false); // Track if the file has been uploaded
  const [file, setFile] = useState(null); // Store the chosen file

  const handleChooseFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const chosenFile = event.target.files[0];

    if (!chosenFile) {
      toast.error("No file selected. Please choose an Excel file.");
      return;
    }

    const validExtensions = ["xlsx", "xls"];
    const fileExtension = chosenFile.name.split(".").pop();

    if (!validExtensions.includes(fileExtension)) {
      toast.error("Invalid file format. Please upload an Excel file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
        header: 1,
      });

      if (sheet.length === 0) {
        toast.error(
          "The Excel file is empty. Please provide data in the required format.",
        );
        return;
      }

      const fileHeaders = sheet[0] || [];
      const requiredHeaders = [
        "entity*",
        "employeeID*",
        "firstName*",
        "lastName*",
        "middleName",
        "nationality*",
        "employeeTypeDesc*",
        "employeeMailId*",
        "employeeMobile*",
        "departmentName*",
        "locationName*",
        "designationName*",
        "role*",
        "ReportingTo(Email)*",
        "DOJ(dd-MM-yyyy)*",
        "BUHead(Email)*",
        "isDeleted(true/false)"
      ];
      // Check if headers match exactly
      const isCorrectFormat =
        requiredHeaders.length === fileHeaders.length &&
        requiredHeaders.every((header, index) => header === fileHeaders[index]);

      if (!isCorrectFormat) {
        toast.error(
          "The Excel file format is incorrect. Please use the sample template.",
        );
        return;
      }

      // Check if the sheet has only headers and no data rows
      if (
        sheet.length === 1 ||
        sheet.slice(1).every((row) => row.every((cell) => !cell))
      ) {
        toast.error(
          "The Excel file contains only headers. Please provide data.",
        );
        return;
      }

      // File is valid and contains data
      toast.success("File is valid. Ready to upload!");
      setFile(chosenFile);
      setFileUploaded(false);
    };

    reader.readAsBinaryString(chosenFile);
  };
  const handleUploadFileClick = () => {
    if (file) {
      readExcelFile(file);
      setFileUploaded(true); // Set file upload status to true
    } else {
      toast.error("Please choose a file first");
    }
  };
  const excelDateToJSDate = (serial) => {
    const utc_days = Math.floor(serial - 25569); // 25569 is the Excel epoch
    const utc_value = utc_days * 86400; // Convert days to seconds
    const date_info = new Date(utc_value * 1000); // Convert seconds to milliseconds
    const month = date_info.getUTCMonth() + 1; // Months are 0-based
    const day = date_info.getUTCDate();
    const year = date_info.getUTCFullYear();
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T00:00:00`;
  };

  const prepareApiData = (jsonData, userId, empId, createdBy) => {
    const currentDateTime = new Date().toISOString();

    return jsonData.map((row) => ({
      userId: parseInt(userId, 10),
      empId: parseInt(empId, 10),
      firstName: String(row["firstName*"] || ""),
      lastName: String(row["lastName*"] || ""),
      middleName: String(row["middleName*"] || ""),
      nationality: String(row["nationality*"] || ""),
      employeeTypeDesc: String(row["employeeTypeDesc*"] || ""),
      entityname: String(row["entity*"] || ""),
      entityId: null,
      employeeNo: String(row["employeeID*"] || ""),
      employeeName: row["firstName*"] || "",
      employeeMailId: row["employeeMailId*"] || "",
      employeeMobile: String(row["employeeMobile*"] || ""),
      locationId: 0,
      departmentId: 0,
      designationId: 0,
      departmentName: row["departmentName*"] || "",
      locationName: row["locationName*"] || "",
      designationName: row["designationName*"] || "",
      isDeleted: false,
      role: row["role*"] || "",
      userPass: "string",
      userName: row["employeeMailId*"] || "",
      createdOn: currentDateTime,
      createdBy: createdBy,
      modifiedOn: currentDateTime,
      modifiedBy: "",
      managerMailID: row["ReportingTo(Email)*"] || "",
      employeeReportingTo: 0,
      employeeDOJ: excelDateToJSDate(row["DOJ(dd-MM-yyyy)*"]),
      buHeadId: 0,
      buHeadMailId: row["BUHead(Email)*"] || "",
      isDeleted: Boolean(row["isDeleted(true/false)"]),
    }));
  };

  const readExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("jsonData", jsonData);
      const userId = localStorage.getItem("USERID");
      const empId = localStorage.getItem("employeeId");
      const createdBy = localStorage.getItem("username");
      const apiData = prepareApiData(jsonData, userId, empId, createdBy);
      console.log("Prepared API data:", apiData);
      try {
        const result = await axios.post("/Employee/AddEmployeeList", apiData);
        console.log("response", result);
        const statusMessage =
          result.data.statusMessage || extractNestedMessage(result.data);
        if (result.data.statusCode !== 0) {
          toast.error(`Error: ${statusMessage}`, true); // Show red error toast
        } else {
          toast.success(statusMessage); // Show success toast
        }

        // Handle failure records if present
        if (
          result.data.failureRecords &&
          result.data.failureRecords.length > 0
        ) {
          result.data.failureRecords.forEach((failure) => {
            const failureMessage = failure.statusMessage || "Unknown error";
            toast.error(`Error in record: ${failureMessage}`, true); // Show red error toast
          });
        }
        // Clear the uploaded file after the API call
        setFile(null); // Reset the file state
        setFileUploaded(false); // Reset the file uploaded status

        // Optionally reset the file input field
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clear the input field
        }
        const fetchEmployeeData = async () => {
          try {
            const response = await axios.get("/Employee/GetAllEmployees");
            setTableData(response.data);
          } catch (error) {
            console.error("Error fetching employee data:", error);
          }
        };
        fetchEmployeeData();
      } catch (error) {
        toast.error(error);
      }
      setSelectedRadio("");
    };
    reader.readAsArrayBuffer(file);
  };
  const extractNestedMessage = (obj) => {
    if (!obj || typeof obj !== "object") return null;
    for (const key in obj) {
      if (key === "statusMessage") return obj[key];
      if (typeof obj[key] === "object") {
        const nestedMessage = extractNestedMessage(obj[key]);
        if (nestedMessage) return nestedMessage;
      }
    }
    return null;
  };
  const handleSampleTemplateClick = () => {
    const sampleData = [
      {
        "entity*": "",
        "employeeID*": "",
        "firstName*": "",
        "lastName*": "",
        middleName: "",
        "nationality*": "",
        "employeeTypeDesc*": "",
        "employeeMailId*": "",
        "employeeMobile*": "",
        "departmentName*": "",
        "locationName*": "",
        "designationName*": "",
        "role*": "",
        "ReportingTo(Email)*": "",
        "DOJ(dd-MM-yyyy)*": "",
        "BUHead(Email)*": "",
        "isDeleted(true/false)": "",
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleData);

    // Set column widths for the headers
    worksheet["!cols"] = [
      { wch: 15 }, // EmpNo
      { wch: 20 }, // EmpName*
      { wch: 15 }, // EmpNumber*
      { wch: 30 }, // EmpMail*
      { wch: 15 }, // EmpMobile*
      { wch: 15 }, // EmpRole*
      { wch: 30 }, // ReportingTo(Email)*
      { wch: 30 }, // DOJ(dd-MM-yyyy)*ss)*
      { wch: 40 }, // BUHead(Email)*
      { wch: 50 }, // Department*
      { wch: 40 }, // Department*
      { wch: 15 }, // IsDeleted
    ];

    // Add a note to indicate required fields

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SampleTemplate");

    // Generate Excel file and download it
    XLSX.writeFile(workbook, "SampleTemplate.xlsx");
  };
  const [selectedVisitorTypes, setSelectedVisitorTypes] = useState([]);
  const handleVisitorTypeChange = (selectedOptions) => {
    setSelectedVisitorTypes(selectedOptions);
  };

  const handleVisitorTypeChangeUpdate = (selectedOptions) => {
    setSelectedVisitorTypesUpdate(selectedOptions);
  };

  return (
    <Container>
      {loading && <Loader />}
      <Header>
        <Heading>Add Employee</Heading>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SearchBox>
            <SearchIcon size={20} />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </SearchBox>
          <DropdownContainerTwo>
            <ExportIcon onClick={togglePanel} title="Export">
              <FiDownload size={25} />
            </ExportIcon>
            {/* Show the panel with options if isPanelOpen is true */}
            {isPanelOpen && (
              <OptionsPanel>
                <OptionItem onClick={() => handleExportOptionClick("excel")}>
                  Excel
                </OptionItem>
                <OptionItem onClick={() => handleExportOptionClick("pdf")}>
                  PDF
                </OptionItem>
              </OptionsPanel>
            )}
          </DropdownContainerTwo>
        </div>
      </Header>
      <Card>
        <RadioGroup>
          <RadioLabel>
            <RadioInput
              type="radio"
              name="visitorType"
              value="addHost"
              checked={selectedRadio === "addHost"}
              onChange={() => {
                setSelectedRadio("addHost");
                setIsModalOpen(true);
                handleReset();
              }}
            />
            Add Employee
          </RadioLabel>
          <RadioLabel>
            <RadioInput
              type="radio"
              name="visitorType"
              value="anotherOption"
              checked={selectedRadio === "anotherOption"}
              onChange={() => setSelectedRadio("anotherOption")}
            />
            Bulk Upload
          </RadioLabel>
        </RadioGroup>
        {selectedRadio === "anotherOption" && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
              gap: "5px",
            }}
          >
            <Button onClick={handleChooseFileClick}>Choose File</Button>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".xlsx,.xls"
              onChange={handleFileChange}
            />
            <Button onClick={handleUploadFileClick}>Upload File</Button>
            <Button onClick={handleSampleTemplateClick}>Sample Template</Button>
          </div>
        )}
      </Card>
      {filteredData.length === 0 && (
        <ZeroStateMessage>No data found.</ZeroStateMessage>
      )}
      {filteredData.length > 0 && (
        <>
          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <TableHeader
                    colSpan={"10"}
                    style={{
                      backgroundColor: "rgb(24, 62, 159)",
                      color: "#fff",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          textAlign: "center",
                          flex: "1",
                          color: "#fff",
                        }}
                      >
                        Employee Details
                      </span>
                      <IconWrapper
                        onClick={toggleExpandCollapse}
                        style={{ cursor: "pointer", color: "#fff" }}
                      >
                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                      </IconWrapper>
                    </div>
                  </TableHeader>
                </tr>
              </thead>
              {isExpanded && (
                <>
                  <thead>
                    <tr>
                      <TableHeader onClick={() => handleSort("entityName")}>
                        Entity Name
                        {sortColumn === "entityName" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("employeeNo")}>
                        Employee Id
                        {sortColumn === "employeeNo" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("employeeName")}>
                        Employee Name
                        {sortColumn === "employeeName" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader
                        onClick={() => handleSort("employeeTypeDesc")}
                      >
                        Employee Type
                        {sortColumn === "employeeTypeDesc" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("nationality")}>
                        Nationality
                        {sortColumn === "nationality" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("employeeMailId")}>
                        Mail Id
                        {sortColumn === "employeeMailId" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("employeeMobile")}>
                        Mobile
                        {sortColumn === "employeeMobile" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("managerMailID")}>
                        Manager Mail Id
                        {sortColumn === "managerMailID" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>
                      <TableHeader onClick={() => handleSort("isDeleted")}>
                        Deleted
                        {sortColumn === "isDeleted" &&
                          (sortDirection === "asc" ? "↑" : "↓")}
                      </TableHeader>

                      <TableHeader>Action</TableHeader>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.entityName}</TableCell>
                        <TableCell>{row.employeeNo}</TableCell>
                        <TableCell>{row.employeeName}</TableCell>
                        <TableCell>{row.employeeTypeDesc}</TableCell>
                        <TableCell>{row.nationality}</TableCell>
                        <TableCell>{row.employeeMailId}</TableCell>
                        <TableCell>{row.employeeMobile}</TableCell>
                        <TableCell>{row.managerMailID}</TableCell>
                        <TableCell>{row.isDeleted ? "Yes" : "No"}</TableCell>
                        <TableCell>
                          <IconWrapper onClick={() => handleEdit(row)}>
                            <FiEdit />
                          </IconWrapper>
                          {/* <IconWrapper>
                            <input
                              type="checkbox"
                              checked={row?.isDeleted}
                              onChange={() => updateDelete(row)}
                            />
                          </IconWrapper> */}
                          {/* <IconWrapper onClick={() => handleDelete(row.employeeNo)}><FiTrash2 /></IconWrapper> */}
                        </TableCell>
                      </TableRow>
                    ))}
                  </tbody>
                </>
              )}
            </StyledTable>
          </TableContainer>
          {isExpanded && (
            <>
              <PaginationContainer>
                <PaginationButton
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </PaginationButton>

                <DropdownSelect value={currentPage} onChange={handlePageChange}>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </DropdownSelect>

                <PaginationButton
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </PaginationButton>
              </PaginationContainer>
            </>
          )}
        </>
      )}
      {isModalOpen && (
        <ModalContainer>
          <ModalHeader>
            <ModalTitle>Add Employee</ModalTitle>
            <CloseIcon size={24} onClick={handleCloseModal} />
          </ModalHeader>
          <InputGroup>
            <InputField>
              <LabelN>Employee Entity</LabelN>
              <Dropdown
                name="entityId"
                value={formValues.entityId}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.entityId ? "red" : "#2B3497",
                  padding: "4px",
                }}
              >
                <option value="">Select Employee Entity</option>
                {empEntity.map((location) => (
                  <option key={location.id} value={location.id}>
                    {location.entityName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.entityId && <span>{formErrors.entityId}</span>}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Id</Label>
              <Input
                type="text"
                name="employeeNo"
                value={formValues.employeeNo}
                onChange={handleInputChange}
                placeholder="Enter Employee Id"
                onKeyDown={(e) => {
                  // Allow alphanumeric characters, Backspace, Delete, Arrow keys, etc.
                  if (
                    !/[a-zA-Z0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                    ].includes(e.key)
                  ) {
                    e.preventDefault(); // Prevent entry of special characters
                  }
                }}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeNo ? "red" : "#2B3497",
                }}
              />
              {formErrors.employeeNo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrors.employeeNo && (
                    <span>{formErrors.employeeNo}</span>
                  )}
                </span>
              )}
            </InputField>
            {/* <InputField>
              <Label>Employee Name</Label>
              <Input
                type="text"
                name="employeeName"
                value={formValues.employeeName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange(e); // Only update state if input is valid
                  }
                }} placeholder="Enter Employee Name"

                style={{ fontSize: "12px", borderColor: formErrors.employeeName ? 'red' : '#2B3497' }}
              />
              {formErrors.employeeName && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.employeeName && <span>{formErrors.employeeName}</span>}
                </span>
              )}
            </InputField> */}
            <InputField>
              <Label required>First Name</Label>
              <Input
                type="text"
                name="firstName"
                value={formValues.firstName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter First Name"
                style={{
                  borderColor: formErrors.firstName ? "red" : "#2B3497",
                  fontSize: "12px",
                }}
              />
              {formErrors.firstName && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrors.firstName}
                </span>
              )}
            </InputField>

            <InputField>
              <LabelN>Middle Name</LabelN>
              <Input
                type="text"
                name="middleName"
                value={formValues.middleName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter Middle Name"
                style={{ fontSize: "12px" }}
              />
            </InputField>

            <InputField>
              <LabelN>Last Name</LabelN>
              <Input
                type="text"
                name="lastName"
                value={formValues.lastName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter Last Name"
                style={{ fontSize: "12px" }}
              />
            </InputField>
            <InputField>
              <Label>Employee Type</Label>
              <Dropdown
                name="employeeTypeDesc"
                value={formValues.employeeTypeDesc}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeTypeDesc ? "red" : "#2B3497",
                }}
              >
                <option value="">Select Employee Type</option>
                {empType.map((location) => (
                  <option key={location.id} value={location.type}>
                    {location.type}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.employeeTypeDesc && (
                  <span>{formErrors.employeeTypeDesc}</span>
                )}
              </span>
            </InputField>

            <InputField>
              <Label>Employee Nationality</Label>
              <Dropdown
                name="nationality"
                value={formValues.nationality}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.nationality ? "red" : "#2B3497",
                }}
              >
                <option value="">Select Nation</option>
                {nationalityList.map((location) => (
                  <option
                    key={location.id}
                    value={location.name}
                    disabled={location.isBlackListed}
                  >
                    {location.name}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.nationality && (
                  <span>{formErrors.nationality}</span>
                )}
              </span>
            </InputField>

            <InputField>
              <Label>Employee Email</Label>
              <Input
                type="email"
                name="employeeMailId"
                value={formValues.employeeMailId}
                onChange={handleInputChange}
                placeholder="Enter Employee Email"
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeMailId ? "red" : "#2B3497",
                }}
              />
              {formErrors.employeeMailId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrors.employeeMailId && (
                    <span>{formErrors.employeeMailId}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <Label>Mobile Number</Label>
              <Input
                type="text"
                name="employeeMobile"
                maxLength={nationalityCode === "91" ? 10 : 15}
                value={formValues.employeeMobile}
                onChange={handleInputChange}
                // onKeyPress={(e) => {
                //   if (!/[0-9]/.test(e.key)) {
                //     e.preventDefault(); // Prevents non-numeric characters
                //   }
                // }}
                placeholder="Enter  Mobile Number"
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeMobile ? "red" : "#2B3497",
                }}
              />
              {formErrors.employeeMobile && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrors.employeeMobile && (
                    <span>{formErrors.employeeMobile}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <Label>Employee Location</Label>
              <Dropdown
                name="employeeLocation"
                value={formValues.employeeLocation}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeLocation ? "red" : "#2B3497",
                }}
              >
                <option value="">Select Location</option>
                {locations.map((location) => (
                  <option key={location.id} value={location.id}>
                    {location.locationName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.employeeLocation && (
                  <span>{formErrors.employeeLocation}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Department</Label>
              <Dropdown
                name="employeeDepartment"
                value={formValues.employeeDepartment}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeDepartment
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Department</option>
                {departments.map((department) => (
                  <option key={department.id} value={department.id}>
                    {department.deptDescription}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.employeeDepartment && (
                  <span>{formErrors.employeeDepartment}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Designation</Label>
              <Dropdown
                name="employeeDesignation"
                value={formValues.employeeDesignation}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeDesignation
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Designation</option>
                {designations.map((designation) => (
                  <option key={designation.id} value={designation.id}>
                    {designation.designationName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.employeeDesignation && (
                  <span>{formErrors.employeeDesignation}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Reporting To</Label>
              <Dropdown
                name="managerMailID"
                value={formValues.managerMailID}
                onChange={(e) => {
                  const selectedManager = managerMails.find(
                    (managerMail) =>
                      managerMail.employeeMailId === e.target.value,
                  );
                  setFormValues({
                    ...formValues,
                    managerMailID: e.target.value,
                    employeeReportingTo: selectedManager
                      ? selectedManager.id
                      : "", // Set employeeReportingTo
                  });
                }}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.managerMailID ? "red" : "#2B3497",
                }}
              >
                <option value="">Select Manager MailID</option>
                {managerMails.map((managerMail) => (
                  <option
                    key={managerMail.id}
                    value={managerMail.employeeMailId}
                  >
                    {managerMail.employeeName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.managerMailID && (
                  <span>{formErrors.managerMailID}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Date of Joining</Label>
              <StyledDatePicker
                name="employeeDOJ"
                placeholderText="Select Date"
                autoComplete="off" // ⛔ Prevent browser autocomplete
                value={formValues.employeeDOJ}
                minDate={new Date()}
                onChange={handleInputChange}
                style={{
                  fontSize: "12px",
                  borderColor: formErrors.employeeDOJ ? "red" : "#2B3497",
                }}
              />
              {formErrors.employeeNo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrors.employeeDOJ && (
                    <span>{formErrors.employeeDOJ}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <Label>BU Head</Label>
              <Dropdown
                name="buHeadMailId"
                value={formValues.buHeadMailId}
                onChange={(e) => {
                  const selectedManager = managerMails.find(
                    (managerMail) =>
                      managerMail.employeeMailId === e.target.value,
                  );
                  setFormValues({
                    ...formValues,
                    buHeadMailId: e.target.value,
                    buHeadId: selectedManager ? selectedManager.id : "", // Set buHeadId
                  });
                }}
                style={{
                  fontSize: "12px",
                  padding: "9.9px 0px",
                  borderColor: formErrors.buHeadMailId ? "red" : "#2B3497",
                }}
              >
                <option value="">Select BU Head</option>
                {managerMails.map((managerMail) => (
                  <option
                    key={managerMail.id}
                    value={managerMail.employeeMailId}
                  >
                    {managerMail.employeeName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrors.buHeadMailId && (
                  <span>{formErrors.buHeadMailId}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <LabelN>Visitor Type</LabelN>
              <Select
                isMulti
                name="visitorType"
                options={visitorTypeOptions}
                value={selectedVisitorTypes}
                onChange={handleVisitorTypeChange}
                closeMenuOnSelect={false}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    fontSize: "12px",
                    border: "none",
                    borderBottom: "2px solid #2B3497",
                    borderRadius: "0px",
                    boxShadow: "none",
                    minHeight: "auto",
                    "&:hover": {
                      borderBottom: "2px solid #2B3497",
                    },
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    flexWrap: "wrap",
                    maxHeight: "80px",
                    overflowY: "auto",
                    padding: "2px 8px",
                    alignItems: "flex-start",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    margin: "2px",
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    color: "#2B3497",
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </InputField>
          </InputGroup>
          <ButtonGroup>
            <ResetButton onClick={handleReset}>Reset</ResetButton>
            <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
          </ButtonGroup>
        </ModalContainer>
      )}
      {isModalOpenUpdate && (
        <ModalContainer>
          <ModalHeader>
            <ModalTitle>Update Employee</ModalTitle>
            <CloseIcon size={24} onClick={handleCloseModalUpdate} />
          </ModalHeader>
          <InputGroup>
            <InputField>
              <LabelN>Employee Entity</LabelN>
              <Dropdown
                name="entityId"
                value={formValuesUpdate.entityId}
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.entityId ? "red" : "#2B3497",
                  padding: "4px",
                }}
              >
                <option value="">Select Employee Entity</option>
                {empEntity.map((location) => (
                  <option key={location.id} value={location.id}>
                    {location.entityName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.entityId && (
                  <span>{formErrorsUpdate.entityId}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Id</Label>
              <Input
                type="text"
                name="employeeNo"
                value={formValuesUpdate.employeeNo}
                onChange={handleInputChangeUpdate}
                placeholder="Enter Employee Id"
                onKeyDown={(e) => {
                  // Allow alphanumeric characters, Backspace, Delete, Arrow keys, etc.
                  if (
                    !/[a-zA-Z0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                    ].includes(e.key)
                  ) {
                    e.preventDefault(); // Prevent entry of special characters
                  }
                }}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeNo ? "red" : "#2B3497",
                }}
              />
              {formErrorsUpdate.employeeNo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrorsUpdate.employeeNo && (
                    <span>{formErrorsUpdate.employeeNo}</span>
                  )}
                </span>
              )}
            </InputField>
            {/* <InputField>
              <Label>Employee Name</Label>
              <Input
                type="text"
                name="employeeName"
                value={formValuesUpdate.employeeName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChangeUpdate(e); // Only update state if input is valid
                  }
                }} placeholder="Enter Employee Name"

                style={{ fontSize: "12px", borderColor: formErrorsUpdate.employeeName ? 'red' : '#2B3497' }}
              />
              {formErrorsUpdate.employeeName && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formErrorsUpdate.employeeName && <span>{formErrorsUpdate.employeeName}</span>}
                </span>
              )}
            </InputField> */}
            <InputField>
              <Label>First Name</Label>
              <Input
                type="text"
                name="firstName"
                value={formValuesUpdate.firstName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChangeUpdate(e); // Only update state if input is valid
                  }
                }}
                placeholder="Enter First Name"
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.firstName ? "red" : "#2B3497",
                }}
              />
              {formErrorsUpdate.firstName && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrorsUpdate.firstName && (
                    <span>{formErrorsUpdate.firstName}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <LabelN>Middle Name</LabelN>
              <Input
                type="text"
                name="middleName"
                value={formValuesUpdate.middleName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChangeUpdate(e); // Only update state if input is valid
                  }
                }}
                placeholder="Enter middle Name"
                style={{ fontSize: "12px" }}
              />
            </InputField>
            <InputField>
              <LabelN>Last Name</LabelN>
              <Input
                type="text"
                name="lastName"
                value={formValuesUpdate.lastName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChangeUpdate(e); // Only update state if input is valid
                  }
                }}
                placeholder="Enter Last Name"
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.lastName ? "red" : "#2B3497",
                }}
              />
              {formErrorsUpdate.lastName && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrorsUpdate.lastName && (
                    <span>{formErrorsUpdate.lastName}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <Label>Employee Type</Label>
              <Dropdown
                name="employeeTypeDesc"
                value={formValuesUpdate.employeeTypeDesc}
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeTypeDesc
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Employee Type</option>
                {empType.map((location) => (
                  <option key={location.id} value={location.type}>
                    {location.type}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.employeeTypeDesc && (
                  <span>{formErrorsUpdate.employeeTypeDesc}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Nationality</Label>
              <Dropdown
                name="name"
                value={formValuesUpdate.name}
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.name ? "red" : "#2B3497",
                }}
              >
                <option value="">Select Nationality</option>
                {nationalityList.map((location) => (
                  <option
                    key={location.id}
                    value={location.name}
                    disabled={location.isBlackListed}
                  >
                    {location.name}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.name && <span>{formErrorsUpdate.name}</span>}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Email</Label>
              <Input
                type="email"
                name="employeeMailId"
                value={formValuesUpdate.employeeMailId}
                onChange={handleInputChangeUpdate}
                placeholder="Enter Employee Email"
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeMailId
                    ? "red"
                    : "#2B3497",
                }}
              />
              {formErrorsUpdate.employeeMailId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrorsUpdate.employeeMailId && (
                    <span>{formErrorsUpdate.employeeMailId}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <Label>Mobile Number</Label>
              <Input
                type="text"
                name="employeeMobile"
                maxLength="15"
                value={formValuesUpdate.employeeMobile}
                onChange={handleInputChangeUpdate}
                // onKeyPress={(e) => {
                //   if (!/[0-9]/.test(e.key)) {
                //     e.preventDefault(); // Prevents non-numeric characters
                //   }
                // }}
                placeholder="Enter  Mobile Number"
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeMobile
                    ? "red"
                    : "#2B3497",
                }}
              />
              {formErrorsUpdate.employeeMobile && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrorsUpdate.employeeMobile && (
                    <span>{formErrorsUpdate.employeeMobile}</span>
                  )}
                </span>
              )}
            </InputField>
            <InputField>
              <Label>Employee Location</Label>
              <Dropdown
                name="employeeLocation"
                value={formValuesUpdate.employeeLocation}
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeLocation
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Location</option>
                {locations.map((location) => (
                  <option key={location.id} value={location.id}>
                    {location.locationName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.employeeLocation && (
                  <span>{formErrorsUpdate.employeeLocation}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Department</Label>
              <Dropdown
                name="employeeDepartment"
                value={formValuesUpdate.employeeDepartment}
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeDepartment
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Department</option>
                {departments.map((department) => (
                  <option key={department.id} value={department.id}>
                    {department.deptDescription}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.employeeDepartment && (
                  <span>{formErrorsUpdate.employeeDepartment}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Employee Designation</Label>
              <Dropdown
                name="employeeDesignation"
                value={formValuesUpdate.employeeDesignation}
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeDesignation
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Designation</option>
                {designations.map((designation) => (
                  <option key={designation.id} value={designation.id}>
                    {designation.designationName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.employeeDesignation && (
                  <span>{formErrors.employeeDesignation}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Reporting To</Label>
              <Dropdown
                name="managerMailID"
                value={formValuesUpdate.managerMailID}
                onChange={(e) => {
                  const selectedManager = managerMails.find(
                    (managerMail) =>
                      managerMail.employeeMailId === e.target.value,
                  );
                  setFormValuesUpdate({
                    ...formValuesUpdate,
                    managerMailID: e.target.value,
                    employeeReportingTo: selectedManager
                      ? selectedManager.id
                      : "", // Set employeeReportingTo
                  });
                }}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.managerMailID
                    ? "red"
                    : "#2B3497",
                }}
              >
                <option value="">Select Manager MailID</option>
                {managerMails.map((managerMail) => (
                  <option
                    key={managerMail.id}
                    value={managerMail.employeeMailId}
                  >
                    {managerMail.employeeName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.managerMailID && (
                  <span>{formErrorsUpdate.managerMailID}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <Label>Date of Joining</Label>
              <StyledDatePicker
                name="employeeDOJ"
                placeholder="Select Date"
                // Use employeeDOJ value directly, but format it correctly for the DatePicker (YYYY-MM-DD)
                value={
                  formValuesUpdate.employeeDOJ
                    ? formValuesUpdate.employeeDOJ.split("T")[0]
                    : ""
                }
                min={new Date().toISOString().split("T")[0]} // Disable past dates
                onChange={handleInputChangeUpdate}
                style={{
                  fontSize: "12px",
                  borderColor: formErrorsUpdate.employeeDOJ ? "red" : "#2B3497",
                }}
                format="yyyy-MM-dd"
              />
              {formErrorsUpdate.employeeDOJ && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formErrorsUpdate.employeeDOJ}
                </span>
              )}
            </InputField>

            <InputField>
              <Label>BU Head</Label>
              <Dropdown
                name="buHeadMailId"
                value={formValuesUpdate.buHeadMailId}
                onChange={(e) => {
                  const selectedManager = managerMails.find(
                    (managerMail) =>
                      managerMail.employeeMailId === e.target.value,
                  );
                  setFormValuesUpdate({
                    ...formValuesUpdate,
                    buHeadMailId: e.target.value,
                    buHeadId: selectedManager ? selectedManager.id : "", // Set buHeadId
                  });
                }}
                style={{
                  fontSize: "12px",
                  padding: "9.9px 0px",
                  borderColor: formErrors.buHeadMailId ? "red" : "#2B3497",
                }}
              >
                <option value="">Select BU Head</option>
                {managerMails.map((managerMail) => (
                  <option
                    key={managerMail.id}
                    value={managerMail.employeeMailId}
                  >
                    {managerMail.employeeName}
                  </option>
                ))}
              </Dropdown>
              <span style={{ color: "red", fontSize: "12px" }}>
                {formErrorsUpdate.buHeadMailId && (
                  <span>{formErrorsUpdate.buHeadMailId}</span>
                )}
              </span>
            </InputField>
            <InputField>
              <LabelN>Visitor Type</LabelN>
              <Select
                isMulti
                name="visitorType"
                options={visitorTypeOptions}
                value={selectedVisitorTypesUpdate}
                onChange={handleVisitorTypeChangeUpdate}
                closeMenuOnSelect={false}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    fontSize: "12px",
                    border: "none",
                    borderBottom: "2px solid #2B3497",
                    borderRadius: "0px",
                    boxShadow: "none",
                    minHeight: "auto",
                    "&:hover": {
                      borderBottom: "2px solid #2B3497",
                    },
                    // Ensure height grows naturally with values
                    flexWrap: "wrap",
                    alignItems: "flex-start",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    flexWrap: "wrap",
                    maxHeight: "80px",
                    overflowY: "auto",
                    padding: "2px 8px",
                    alignItems: "flex-start",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    margin: "2px",
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    color: "#2B3497",
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </InputField>
            <InputFieldCheckbox>
              <input
                type="checkbox"
                checked={formValuesUpdate?.isDeleted}
                onChange={() =>
                  setFormValuesUpdate((prev) => ({
                    ...prev,
                    isDeleted: !formValuesUpdate?.isDeleted,
                  }))
                }
              />
              <LabelN>IsDeleted</LabelN>
            </InputFieldCheckbox>
          </InputGroup>

          <ButtonGroup>
            <ResetButton onClick={handleResetUpdate}>Reset</ResetButton>
            <SubmitButton onClick={handleSubmitUpdate}>Submit</SubmitButton>
          </ButtonGroup>
        </ModalContainer>
      )}
      <ToastContainer />
    </Container>
  );
};

export default AddEmployeePage;
